import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { TrackClickRequestDto, TrackClickResponseDto } from '../dto';

type TrackClickOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export function trackClick(
  baseUrl: string,
  payload: TrackClickRequestDto,
  options?: TrackClickOptions,
): Promise<IHttpResponse<TrackClickResponseDto>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<TrackClickRequestDto> = {
    url: `${baseUrl}/ranking/click/event`,
    method: 'POST',
    body: payload,
    headers,
    schemas: {
      request: TrackClickRequestDto,
      response: TrackClickResponseDto,
    },
    ...restOptions,
  };

  return httpCall(request);
}
